import { useEffect, useRef } from 'react';

// Module-level stack of open modal IDs (oldest → newest).
// Ensures only the topmost modal responds to the browser back gesture.
const modalStack: string[] = [];
let counter = 0;

export function useModalHistory(onClose: () => void, enabled: boolean = true) {
  const onCloseRef = useRef(onClose);
  useEffect(() => { onCloseRef.current = onClose; });

  useEffect(() => {
    if (!enabled) return;

    const id = String(++counter);
    modalStack.push(id);
    window.history.pushState({ modal: id }, '', window.location.href);

    const handlePopState = () => {
      if (modalStack[modalStack.length - 1] !== id) return;
      modalStack.pop();
      onCloseRef.current();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      const idx = modalStack.indexOf(id);
      if (idx !== -1) modalStack.splice(idx, 1);
    };
  }, [enabled]);
}
